interface Props {
  vueTout: boolean;
  onChange: (vueTout: boolean) => void;
  /** Nombre d'elements caches par le filtre, pour que le choix soit eclaire. */
  caches: number;
}

/**
 * Bascule entre « ce qui me concerne » et « tout le foyer ».
 *
 * Par defaut on ne voit que ce qui nous est assigne, plus ce qui n'est
 * assigne a personne : a 6 h du matin, la liste doit repondre a « qu'est-ce
 * que je dois faire », pas « que se passe-t-il dans la maison ». Le compteur
 * a droite evite l'effet boite noire — on sait toujours combien on ne voit
 * pas.
 */
export function BasculeVue({ vueTout, onChange, caches }: Props) {
  return (
    <div className="bascule" role="group" aria-label="Filtrer la liste">
      <button
        type="button"
        className={vueTout ? '' : 'actif'}
        onClick={() => onChange(false)}
        aria-pressed={!vueTout}
      >
        Moi
      </button>
      <button
        type="button"
        className={vueTout ? 'actif' : ''}
        onClick={() => onChange(true)}
        aria-pressed={vueTout}
      >
        Tout
        {!vueTout && caches > 0 && <span className="compteur">{caches}</span>}
      </button>
    </div>
  );
}
